import { Controller } from 'react-hook-form';
import { InputText, SidePanelRow, Checkbox } from '@ui/src';

import { ChartPanelAccountProps } from './types';

import cn from './styles.module.css';

const ChartPanelGroup = ({
  category,
  control,
  errors,
  groupId,
  groupNumber,
}: ChartPanelAccountProps): React.JSX.Element => (
  <>
    <SidePanelRow caption="Parent category">
      {`${category?.number}. ${category?.name}`}
    </SidePanelRow>

    <SidePanelRow caption="Group name">
      <Controller
        control={control}
        defaultValue=""
        name="description"
        render={({ field: { onChange, value } }) => (
          <InputText
            placeholder="Enter name..."
            name="description"
            value={value}
            onChange={onChange}
            error={errors.description?.message}
          />
        )}
      />
    </SidePanelRow>
    {groupId && (
      <SidePanelRow>
        <Controller
          control={control}
          defaultValue={false}
          name="active"
          render={({ field: { onChange, value } }) => (
            <Checkbox
              type="checkbox"
              name="active"
              checked={value}
              title="Active"
              onChange={(e) => onChange(e.target.checked)}
            />
          )}
        />
      </SidePanelRow>
    )}

    <SidePanelRow caption="Account type">
      <div className={cn.categoryType}>{`${category?.type?.charAt(
        0,
      )}${category?.type?.slice(1).toLowerCase()}`}</div>
    </SidePanelRow>

    <SidePanelRow caption="New group number" resultBlock>
      {/* TODO: Новый номер группы, т.е. ID вичисляется на сервере */}
      <h3>{`${category?.number}. ${groupNumber}`}</h3>
    </SidePanelRow>
  </>
);

export default ChartPanelGroup;
